import Header from "@/components/marketing/Header";
import Footer from "@/components/marketing/Footer";
import SEO from "@/components/marketing/SEO";
import PricingCards from "@/components/marketing/PricingCards";
import BillingNote from "@/components/marketing/BillingNote";
import FeaturesDetailed from "@/components/marketing/FeaturesDetailed";
import Guarantees from "@/components/marketing/Guarantees";
import ActivationOption from "@/components/marketing/ActivationOption";
import FinalCTA from "@/components/marketing/FinalCTA";

const Pricing = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Tarifs Piktable · 49 CHF ou 29 CHF à vie · sans commission"
        description="Tarifs Piktable : 49 CHF par mois, ou 29 CHF à vie pour les 50 fondateurs du Printemps 2026. Facturation annuelle, résiliable à tout moment, zéro commission par couvert."
        canonical="/pricing"
      />
      <Header />
      <main className="pt-16">
        <section className="py-20 bg-gradient-hero">
          <div className="container mx-auto px-4 text-center max-w-3xl">
            <h1 className="font-playfair text-4xl md:text-6xl font-bold text-foreground mb-6">
              Tarifs simples, sans commission.
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              Deux prix, quatre chemins pour y accéder. Tout inclus, sans limite,
              sans frais cachés.
            </p>
          </div>
        </section>

        <PricingCards
          heading="Deux prix, quatre chemins."
          subheading="Choisis l'offre qui te correspond. Commence par 30 ou 60 jours gratuits."
          showReferral
        />

        <BillingNote />

        <FeaturesDetailed />

        <ActivationOption />

        <Guarantees />

        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
